export function devConsoleLog(...args: any) {
    if (process.env.REACT_APP_ENVIRONMENT === 'dev') {
        console.log(...args);
    }
}
